export * from "./color";

export const mobRgx = /[6-9]{1}[0-9]{9}/;
export const numberRgx = /^[0-9]{0,10}$/;
export const decimalNumbers = /^([0-9]+\.?[0-9]*|\.[0-9]+)$/;

export const commonFormatedDate = (date, separator, sequence) => {
  var d = new Date(date),
    month = "" + (d.getMonth() + 1),
    day = "" + d.getDate(),
    year = d.getFullYear();

  if (month.length < 2) month = "0" + month;
  if (day.length < 2) day = "0" + day;

  const dateObject = {
    day,
    month,
    year,
  };
  return [
    dateObject[sequence[0]],
    dateObject[sequence[1]],
    dateObject[sequence[2]],
  ].join(separator);
};
